import React from 'react';
import { useRezaListContext, useRezaLocale } from '@gov-nx/module/page';
import {
	Button,
	Dialog,
	DSGovFlex,
	FormDatePicker,
	FormLegend,
	FormWidthElementLayout,
	LayoutGap,
} from '@gov-nx/ui/web';

export const FilterModal = () => {
	const { t } = useRezaLocale();
	const {
		isFilterModalOpen,
		onFilterReset,
		isFilterModalActive,
		formDefinition,
	} = useRezaListContext();

	return (
		<Dialog
			isOpen={isFilterModalOpen.isTrue}
			onClose={isFilterModalOpen.setFalse}
			title={<h3>{t('seznam.modal.title')}</h3>}
			footer={
				<>
					{isFilterModalActive ? (
						<Button
							onClick={onFilterReset}
							color="error"
							type="outlined"
							size="m"
							aria-label={t('akce.zrusit-filtr.wcag')}
							isExpandedMobile>
							{t('akce.zrusit-filtr.label')}
						</Button>
					) : null}
					<Button
						color="primary"
						type="solid"
						size="m"
						nativeType="submit"
						aria-label={t('akce.filtrovat.wcag')}
						isExpandedMobile>
						{t('akce.filtrovat.label')}
					</Button>
				</>
			}>
			<LayoutGap gap="m">
				<FormLegend>{t('seznam.modal.platnost-od.label')}</FormLegend>
				<DSGovFlex gap="l">
					<FormWidthElementLayout>
						<FormDatePicker {...formDefinition.fields.platnostOdOd} />
					</FormWidthElementLayout>
					<FormWidthElementLayout>
						<FormDatePicker {...formDefinition.fields.platnostOdDo} />
					</FormWidthElementLayout>
				</DSGovFlex>

				<FormLegend>{t('seznam.modal.platnost-do.label')}</FormLegend>
				<DSGovFlex gap="l">
					<FormWidthElementLayout>
						<FormDatePicker {...formDefinition.fields.platnostDoOd} />
					</FormWidthElementLayout>
					<FormWidthElementLayout>
						<FormDatePicker {...formDefinition.fields.platnostDoDo} />
					</FormWidthElementLayout>
				</DSGovFlex>
			</LayoutGap>
		</Dialog>
	);
};
